
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spikex-card",
      function () {
        return require("private-next-pages/spikex-card/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spikex-card"])
      });
    }
  